import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CallDetailModel, HxCallService, HxFioPipe } from 'hx-services';
import { ErrorHandlerService } from '@callcenter-app/service/error-handler.service';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { HxLoaderComponent } from 'hx-component';

@Component({
  selector: 'app-call-details',
  templateUrl: './call-details.component.html',
  styleUrls: ['./call-details.component.css'],
  imports: [NgIf, NgFor, NgClass, NgbTooltip, DatePipe, HxLoaderComponent, HxFioPipe]
})
export class CallDetailsComponent implements OnInit {

  @Input() callId!: string;
  callDetails: CallDetailModel[] = [];
  isLoading = {
    list: false,
  };

  constructor(
    public modal: NgbActiveModal,
    private callService: HxCallService,
    private errorHandlerService: ErrorHandlerService,
  ) {
  }

  async ngOnInit() {
    this.isLoading.list = true;
    try {
      this.callDetails = await this.callService.getCallDetailsByCallId(this.callId);
    } catch (err: any) {
      this.errorHandlerService.check(err);
    } finally {
      this.isLoading.list = false;
    }
  }
}
